module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event d-flex p-1 bg-lightest relative border-light"
  }, [_c('div', {
    staticClass: "image radius-normal bg-lighter"
  }, [(_vm.image) ? _c('img', {
    attrs: {
      "src": _vm.image
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info mx-5 my-3 flex-all"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [(_vm.product) ? _c('h4', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.product.name))]) : _vm._e()]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.brand))]), _vm._v(" "), _c('ul', {
    staticClass: "settings d-flex justify-content-between mt-5 bold"
  }, [_c('li', [_c('div', {
    staticClass: "fs-small normal"
  }, [_vm._v("Date")]), _vm._v("\n                " + _vm._s(_vm.dates['start_date']) + "\n\n                "), (_vm.dates['start_date'] != _vm.dates['end_date']) ? _c('span', [_vm._v("\n                    to " + _vm._s(_vm.dates['end_date']) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "fs-small normal"
  }, [_vm._v("Time")]), _vm._v("\n                " + _vm._s(_vm.dates['start_time']) + " - " + _vm._s(_vm.dates['end_time']) + "\n            ")]), _vm._v(" "), (_vm.product) ? _c('li', [_c('div', {
    staticClass: "fs-small normal"
  }, [_vm._v("Departure location")]), _vm._v("\n                " + _vm._s(_vm.product.locationCompleted.name) + "\n            ")]) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-457f50f4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-457f50f4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/BasicData.vue
// module id = 2033
// module chunks = 0